export const CComparisonTableFragments = {
  field: `
    fragment comparisonTable on comparisonTable_MatrixField {
      ... on comparisonTable_main_Entry {
        id
        typeHandle
        idName
        heading
        headingUsSite
        homepageHeading
        copy
        copyUs
        disableColumns
      }
      ... on comparisonTable_tableHeader_Entry {
        id
        typeHandle
        tableHeader {
          mainHeading
          columnHeading1
          columnHeading2
          columnHeading3
        }
      }
      ... on comparisonTable_tableBody_Entry {
        id
        typeHandle
        tableBody {
          rowHeading
          data1
          data1V2
          data2
          data2V2
          data3
          data3V2
          data1Asterisks
          data2Asterisks
          data3Asterisks
          data1Superscript
          data2Superscript
          data3Superscript
        }
      }
      ... on comparisonTable_tableFooter_Entry {
        id
        typeHandle
        tableFooter {
          mainNote
          columnNote1
          columnNote2
          columnNote3
        }
      }
      ... on comparisonTable_tableFooterDisclaimerText_Entry {
        disclaimerText
      }
    }
  `,
}
